import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

// Midnight at the start of 10 October 2026 in the UK (British Summer Time).
const NOTICE_END_TIME = new Date('2026-10-09T23:00:00Z').getTime();

const HolidayNotice = () => {
  const [isVisible, setIsVisible] = useState(() => Date.now() < NOTICE_END_TIME);

  useEffect(() => {
    if (!isVisible) return undefined;

    const timeUntilRemoval = NOTICE_END_TIME - Date.now();
    const timeoutId = window.setTimeout(
      () => setIsVisible(false),
      Math.max(0, timeUntilRemoval),
    );

    return () => window.clearTimeout(timeoutId);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <motion.aside
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: 'easeOut' }}
      className="relative overflow-hidden bg-[#fbf5f0] border-b border-rose-gold-light pt-24"
      role="status"
      aria-labelledby="holiday-notice-title"
    >
      <div className="absolute -top-16 -right-14 h-48 w-48 rounded-full bg-rose-gold-light/45" aria-hidden="true" />
      <div className="absolute -bottom-20 -left-12 h-40 w-40 rounded-full border-[24px] border-white/70" aria-hidden="true" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 py-7 md:py-9">
        <div className="grid md:grid-cols-[auto_1fr] gap-5 md:gap-7 items-start">
          <div className="hidden md:flex h-14 w-14 items-center justify-center rounded-full bg-white shadow-sm border border-rose-gold-light">
            <SafeIcon icon={FiIcons.FiCalendar} className="text-2xl text-rose-gold-dark" />
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-rose-gold-dark mb-2">Annual holiday notice</p>
            <h2 id="holiday-notice-title" className="font-serif text-2xl md:text-3xl font-bold leading-tight text-gray-900">
              We’re currently closed and reopen Saturday 10 October.
            </h2>
            <p className="mt-3 text-gray-700 leading-relaxed max-w-3xl">
              We’ll respond to all messages and appointment enquiries as soon as possible when we return. Home visits and clinic appointments will be available again from Saturday 10 October.
            </p>
            <p className="mt-4 text-sm md:text-base font-medium text-gray-800 flex items-start gap-2">
              <SafeIcon icon={FiIcons.FiHeart} className="mt-1 flex-shrink-0 text-rose-gold-dark" />
              <span>Thank you for your patience and understanding. We look forward to helping you hear clearly again!</span>
            </p>
          </div>
        </div>
      </div>
    </motion.aside>
  );
};

export default HolidayNotice;
